let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Wdqb")).then(() => parcelRequire('7W27q'));